/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useRef } from 'react';
import { Card, Form, Button, Modal, InputGroup } from 'react-bootstrap';
// import {
//   PencilIcon,
//   MailIcon,
//   PhoneIcon,
//   DocumentAddIcon,
//   WifiIcon,
// } from "@heroicons/react/solid";
import { ChoosePhotoWidget } from '@vlinder-web/choose-photo-widget-react';

export interface IEditGroupModel {
  showModal?: boolean;
  createModalLabel?: string;
  nameLabel?: string;
  logoLabel?: string;
  emailLabel?: string;
  phoneNumberLabel?: string;
  addressLabel?: string;
  websiteLabel?: string;
  descriptionLabel?: string;
  submitButtonText?: string;
  signupButtonStyle?: any;
  defaultName?: string;
  defaultEmail?: string;
  defaultPhoneNumber?: string;
  defaultAddress?: string;
  defaultWebsite?: string;
  defaultDescription?: string;
  defaultProfileImg?: string;
  onAcknowledgement?(
    name: string,
    description: string,
    email: string,
    phoneNumber: string,
    address: string,
    website: string,
    profileImg?: string
  ): void;
  onDeny?(): void;
}

export const EditProfileModal = ({
  showModal,
  createModalLabel,
  nameLabel,
  logoLabel,
  emailLabel,
  phoneNumberLabel,
  websiteLabel,
  addressLabel,
  descriptionLabel,
  defaultAddress,
  defaultEmail,
  defaultWebsite,
  defaultName,
  defaultPhoneNumber,
  defaultDescription,
  submitButtonText,
  signupButtonStyle,
  onDeny,
  onAcknowledgement,
  defaultProfileImg,
}: IEditGroupModel) => {
  const [show, setShow] = useState(showModal);
  const [profileImg, setProfileImg] = useState<any>(null);
  const nameRef = useRef(null);
  const contactRef = useRef(null);
  const addressRef = useRef(null);
  const websiteRef = useRef(null);
  const descriptionRef = useRef(null);

  const handleClose = () => {
    if (onDeny) {
      onDeny();
    }
    setShow(false);
  };

  const handlePhotoChosen = (file: any) => {
    setProfileImg(file?.base64);
  };

  const _onFormSubmit = (event: any) => {
    if (event) {
      event.preventDefault();
      if (onAcknowledgement) {
        onAcknowledgement(
          nameRef?.current?.value,
          descriptionRef?.current?.value,
          contactRef?.current?.value,
          addressRef?.current?.value,
          websiteRef?.current?.value,
          profileImg
        );
      }
      // 👇️ clear all input values in the form
      event.target.reset();
    }
    setShow(false);
  };

  return (
    <Modal centered show={show} onHide={handleClose}>
      <Modal.Header className="border-0">
        <Button variant="close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body className="p-0">
        <Card border="light" className="px-0 px-md-4 py-0 border-0">
          <Card.Header className="text-center text-md-center border-0 mb-0 mt-md-0">
            <h4>{createModalLabel}</h4>
          </Card.Header>
          <Card.Body>
            <Form onSubmit={_onFormSubmit}>
              <Form.Group className="mb-4">
                <ChoosePhotoWidget
                  title={logoLabel}
                  multiple={false}
                  onDone={handlePhotoChosen}
                  photo={defaultProfileImg}
                />
              </Form.Group>
              <Form.Group id="name" className="mb-4">
                <Form.Label>{nameLabel}</Form.Label>
                <InputGroup>
                  {/*<InputGroup.Text className="text-gray-500">*/}
                  {/*  <DocumentAddIcon className="icon icon-xs" />*/}
                  {/*</InputGroup.Text>*/}
                  <Form.Control
                    ref={nameRef}
                    autoFocus
                    required
                    type="text"
                    defaultValue={defaultName}
                  />
                </InputGroup>
              </Form.Group>
              <Form.Group id="description" className="mb-4">
                <Form.Label>{descriptionLabel}</Form.Label>
                <InputGroup>
                  {/*<InputGroup.Text className="text-gray-500">*/}
                  {/*  <DocumentAddIcon className="icon icon-xs" />*/}
                  {/*</InputGroup.Text>*/}
                  <Form.Control
                    ref={descriptionRef}
                    as="textarea"
                    rows="2"
                    defaultValue={defaultDescription}
                  />
                </InputGroup>
              </Form.Group>
              <Form.Group id="phone-number" className="mb-4">
                <Form.Label>{phoneNumberLabel}</Form.Label>
                <InputGroup>
                  {/*<InputGroup.Text className="text-gray-500">*/}
                  {/*  <PhoneIcon className="icon icon-xs" />*/}
                  {/*</InputGroup.Text>*/}
                  <Form.Control
                    ref={contactRef}
                    autoFocus
                    type="text"
                    defaultValue={defaultPhoneNumber}
                  />
                </InputGroup>
              </Form.Group>
              <Form.Group id="address" className="mb-4">
                <Form.Label>{addressLabel}</Form.Label>
                <InputGroup>
                  {/*<InputGroup.Text className="text-gray-500">*/}
                  {/*  <PencilIcon className="icon icon-xs" />*/}
                  {/*</InputGroup.Text>*/}
                  <Form.Control
                    as="textarea"
                    rows="3"
                    ref={addressRef}
                    defaultValue={defaultAddress}
                  />
                </InputGroup>
              </Form.Group>
              <Form.Group id="website" className="mb-4">
                <Form.Label>{websiteLabel}</Form.Label>
                <InputGroup>
                  {/*<InputGroup.Text className="text-gray-500">*/}
                  {/*  <WifiIcon className="icon icon-xs" />*/}
                  {/*</InputGroup.Text>*/}
                  <Form.Control
                    ref={websiteRef}
                    autoFocus
                    type="text"
                    defaultValue={defaultWebsite}
                  />
                </InputGroup>
              </Form.Group>
              <div className="d-grid">
                <Button
                  variant="gray-800"
                  type="submit"
                  style={signupButtonStyle}
                >
                  {submitButtonText}
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Modal.Body>
    </Modal>
  );
};

EditProfileModal.defaultProps = {
  showModal: false,
  createModalLabel: 'Edit Organization Info',
  nameLabel: 'Organization Name',
  descriptionLabel: 'Description',
  emailLabel: 'Email Address',
  phoneNumberLabel: 'Contact No.',
  addressLabel: 'Address',
  websiteLabel: 'Website',
  submitButtonText: 'Edit Organization',
  logoLabel: 'Organization Logo',
};
